<template>
  <div class="greenhouseManagement-page">
    <div class="all-content-container" style="width: 100%; overflow: hidden">
      <div class="left-content-container">
        <div class="left-header-container">
          <h4>监测统计</h4>
          <div>
            <el-date-picker
              v-model="value3"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              @change="initcx"
              value-format="yyyy-MM-dd"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </div>
        </div>
        <div class="left-echarts-container">
          <h3 style="color: #333; ont-size: 14px !important; margin-top: 10px">
            环境参数
            <a class="sz-btn" @click="dialogShow('0')">设置</a>
          </h3>
          <div
            id="mainOne"
            v-show="hjempty"
            style="width: 376px; height: 273px"
          ></div>
          <div class="empty-div" v-show="!hjempty" @click="dialogShow('0')">
            还未添加参数，点击添加参数
          </div>
          <h3 style="color: #333; ont-size: 14px !important; margin-top: 10px">
            土壤参数
            <a class="sz-btn" @click="dialogShow('1')">设置</a>
          </h3>
          <div
            id="mainTwo"
            v-show="trempty"
            style="width: 376px; height: 273px"
          ></div>
          <div class="empty-div" v-show="!trempty" @click="dialogShow('1')">
            还未添加参数，点击添加参数
          </div>
          <h3 style="color: #333; ont-size: 14px !important; margin-top: 10px">
            告警参数
            <a class="sz-btn" @click="dialogShow('2')">设置</a>
          </h3>
          <div
            id="mainThree"
            v-show="gjempty"
            style="width: 376px; height: 273px"
          ></div>
          <div class="empty-div" v-show="!gjempty" @click="dialogShow('2')">
            还未添加参数，点击添加参数
          </div>
        </div>
      </div>
      <div class="mid-content-container">
        <router-link to="regionalMapManagement">
          <h4><i class="el-icon-caret-left"></i>返回区域</h4>
        </router-link>
        <div class="dpsj">
          <div class="dpsj-left">
            <div
              class="dpxx gz"
              v-for="(item, index) in envarr"
              :key="index"
              @click="toDeviceManagement(item)"
            >
              <img class="gzImg2" :src="item.attributeImage" />
              <span
                >{{ item.attributeName }}：{{ item.realDataConvert
                }}{{ item.attributeSymbol }}</span
              >
            </div>
          </div>
          <div class="dpsj-right">
            <div
              class="dpxx gz"
              v-for="(item, index) in envarr2"
              :key="index"
              @click="toDeviceManagement(item)"
            >
              <img class="gzImg2" :src="item.attributeImage" />
              <span
                >{{ item.attributeName }}：{{ item.realDataConvert
                }}{{ item.attributeSymbol }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="right-content-container">
        <div class="left-header-container">
          <h4>能耗统计</h4>
          <div>
            <el-date-picker
              v-model="value4"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              :default-time="['00:00:00', '23:59:59']"
              @change="inite"
            ></el-date-picker>
          </div>
        </div>
        <div class="left-echarts-container">
          <h3 style="color: #333; ont-size: 14px !important; margin-top: 10px">
            电压功耗参数
          </h3>
          <div id="mainFour" style="width: 376px; height: 273px"></div>
          <h3 style="color: #333; ont-size: 14px !important; margin-top: 10px">
            电流功耗参数
          </h3>
          <div id="mainFive" style="width: 376px; height: 273px"></div>
          <h3 style="color: #333; ont-size: 14px !important; margin-top: 10px">
            有功电度功耗参数
          </h3>
          <div id="mainSix" style="width: 376px; height: 273px"></div>
        </div>
      </div>
    </div>
    <el-dialog
      title="视频监控"
      :visible.sync="centerDialogVisible"
      width="800px"
      center
    >
      <div style="width: 750px; height: 100%">
        <player
          :id="'play1'"
          :deviceUrl="deviceUrl"
          :accessToken="ysAccessToken"
        ></player>
      </div>
    </el-dialog>
    <!-- 数据图弹窗 -->
    <el-dialog
      :title="dialogShowname"
      :visible.sync="dialogVisible"
      width="800px"
      height="500px"
      :before-close="handleClose1"
      :close-on-click-modal="false"
      class="sjtc"
      @open="open()"
    >
      <div style="margin-right: 20px">
        <el-tag
          :key="tag"
          v-for="tag in dynamicTags"
          closable
          :disable-transitions="false"
          @close="handleClosetag(tag)"
          >{{ tag }}</el-tag
        >
        <el-input
          class="input-new-tag"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        ></el-input>
        <el-button
          v-if="dynamicTags.length < 2"
          class="button-new-tag"
          style="position: relative; bottom: -2px"
          size="small"
          @click="showInput"
          >+ 添加属性</el-button
        >
      </div>
      <div
        id="mainSeven"
        style="width: 100%; height: 400px; margin-top: 20px"
      ></div>
    </el-dialog>
    <el-dialog
      title="设备属性"
      :visible.sync="dialogVisible2"
      width="800px"
      height="500px"
      :before-close="handleClose2"
      :close-on-click-modal="false"
      class="sjtc"
      @open="open"
    >
      <el-form ref="form" :model="form" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="设备名称：">
              <el-select v-model="eid" @change="value_val" placeholder="请选择">
                <el-option
                  v-for="item in deviceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备属性：">
              <el-select v-model="attributeId" placeholder="请选择">
                <el-option
                  v-for="item in attributeList"
                  :key="item.id"
                  :label="item.cname"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer1">
        <el-button @click="handleClose2">取 消</el-button>
        <el-button type="primary" @click="handleInputConfirm('dialogform')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import echarts from "echarts";
import player from "@/components/play/EZUIPlayer.vue";

export default {
  name: "greenhouseManagement",
  components: {
    player,
  },
  data() {
    return {
      envarr: [],
      envarr2: [],
      getVideosListname: "",
      getVideosListplayRtmp: "",
      getVideosListplayM3u8: "",

      hjempty: false,
      trempty: false,
      gjempty: false,
      dialogShowname: "环境参数图表设置",
      dynamicTags0: [], //环境tag
      dynamicTags1: [], //土壤tag
      dynamicTags2: [], //告警tag
      dynamicTags: [],

      attributes: [],
      attributes1: [],

      inputVisible: false,
      inputValue: "",
      dialogVisible2: false,
      attributes2: [],
      value4: [],
      value3: [],
      value1: "",
      value: "",

      options1: [
        {
          value: "选项1",
          label: "温度",
        },
        {
          value: "选项2",
          label: "湿度",
        },
      ],
      form: {
        name: "",
      },

      dialogVisible: false,
      spList: {
        msg: "查询成功",
        code: 200,
        data: [
          {
            deviceType: 1,
            groupId: 1,
            updateTime: 1576235520815,
            deviceCode: "677074916",
            deviceId: 1,
            deviceName: "杭州101摄像头",
            userId: 1,
            isAuthorize: 0,
            deviceStatus: 1,
            colorType: "",
            attributeId: 343,
            alarmType: "",
            deviceM3u8:
              "http://hls01open.ys7.com/openlive/f1c76c6699354b69aaf6b0b0a84ff902.hd.m3u8",
            deviceRtmp:
              "rtmp://rtmp01open.ys7.com/openlive/f1c76c6699354b69aaf6b0b0a84ff902.hd",
            authorizeId: 0,
            deviceUrl: "ezopen://open.ys7.com/677074916/1.hd.live",
            attributeName: "视频监控",
            realData: "",
          },
          {
            deviceType: 1,
            groupId: 15,
            updateTime: 1576235521454,
            deviceCode: "C96165545",
            deviceId: 3,
            deviceName: "实验室展厅1号",
            userId: 1,
            isAuthorize: 0,
            deviceStatus: 1,
            colorType: "",
            attributeId: 343,
            alarmType: "",
            deviceM3u8:
              "http://hls01open.ys7.com/openlive/001a43a37cd04b9093fe371371d4bd08.hd.m3u8",
            deviceRtmp:
              "rtmp://rtmp01open.ys7.com/openlive/001a43a37cd04b9093fe371371d4bd08.hd",
            authorizeId: 0,
            deviceUrl: "ezopen://open.ys7.com/C96165545/1.hd.live",
            attributeName: "视频监控",
            realData: "",
          },
          {
            deviceType: 1,
            groupId: 25,
            updateTime: 1576235521048,
            deviceCode: "234675206",
            deviceId: 5,
            deviceName: "实验室展厅2号",
            userId: 1,
            isAuthorize: 0,
            deviceStatus: 1,
            colorType: "",
            attributeId: 343,
            alarmType: "",
            deviceM3u8:
              "http://hls01open.ys7.com/openlive/57d638b3fb504bbeaa89051ea5f82737.hd.m3u8",
            deviceRtmp:
              "rtmp://rtmp01open.ys7.com/openlive/57d638b3fb504bbeaa89051ea5f82737.hd",
            authorizeId: 0,
            deviceUrl: "ezopen://open.ys7.com/234675206/1.hd.live",
            attributeName: "视频监控",
            realData: "",
          },
          {
            deviceType: 1,
            groupId: 25,
            updateTime: 1576235520692,
            deviceCode: "D34698989",
            deviceId: 6,
            deviceName: "实验室展厅3号",
            userId: 1,
            isAuthorize: 0,
            deviceStatus: 1,
            colorType: "",
            attributeId: 343,
            alarmType: "",
            deviceM3u8:
              "http://hls01open.ys7.com/openlive/2b4ae9913fc046bab18fba4144d86225.hd.m3u8",
            deviceRtmp:
              "rtmp://rtmp01open.ys7.com/openlive/2b4ae9913fc046bab18fba4144d86225.hd",
            authorizeId: 0,
            deviceUrl: "ezopen://open.ys7.com/D34698989/1.hd.live",
            attributeName: "视频监控",
            realData: "",
          },
          {
            deviceType: 1,
            groupId: 28,
            updateTime: 1576235520934,
            deviceCode: "C91935614",
            deviceId: 8,
            deviceName: "实验室展厅4号",
            userId: 1,
            isAuthorize: 0,
            deviceStatus: 1,
            colorType: "",
            attributeId: 343,
            alarmType: "",
            deviceM3u8:
              "http://hls01open.ys7.com/openlive/9758d16dc1fa478dba1d372f5e07acb3.hd.m3u8",
            deviceRtmp:
              "rtmp://rtmp01open.ys7.com/openlive/9758d16dc1fa478dba1d372f5e07acb3.hd",
            authorizeId: 0,
            deviceUrl: "ezopen://open.ys7.com/C91935614/1.hd.live",
            attributeName: "视频监控",
            realData: "",
          },
          {
            deviceType: 1,
            groupId: 1,
            updateTime: 1576235520562,
            deviceCode: "D58107115",
            deviceId: 10,
            deviceName: "杭州102摄像头",
            userId: 1,
            isAuthorize: 0,
            deviceStatus: 1,
            colorType: "",
            attributeId: 343,
            alarmType: "",
            deviceM3u8:
              "http://hls01open.ys7.com/openlive/fc0c3a48e2c64591a2d84f073fc8ecdb.hd.m3u8",
            deviceRtmp:
              "rtmp://rtmp01open.ys7.com/openlive/fc0c3a48e2c64591a2d84f073fc8ecdb.hd",
            authorizeId: 0,
            deviceUrl: "ezopen://open.ys7.com/D58107115/1.hd.live",
            attributeName: "视频监控",
            realData: "",
          },
        ],
        pageInfo: { pageNum: 1, pages: 1, total: 6 },
      },
      centerDialogVisible: false,
      timeType: 1,
      timeType1: 1,
      value2: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [end, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      deviceList: [],
      pageNum: 1,
      pageSize: 9999,
      attributeName: "",
      deviceType: "",
      getVideosList: [],
      attributeList: [],
      attributeId: "",
      eid: "",
      startDate: "",
      statisticType: "",
      dateType: "0",
      mode: 0,
    };
  },
  watch: {},
  created() {
    let now = new Date();
    let year = now.getFullYear(); //得到年份
    let month = now.getMonth(); //得到月份
    let date = now.getDate(); //得到日期
    month = month + 1;
    month = month.toString().padStart(2, "0");
    date = date.toString().padStart(2, "0");
    let defaultDate = `${year}-${month}-${date}`;
    this.value3 = [defaultDate, defaultDate];
    this.value4 = [defaultDate, defaultDate];
    var _this = this;
    this.id = this.$route.query.id;
    this.getVideos(this.id);
  },
  mounted() {
    this.getNumericalsByGroupId();
    this.initcx();
    this.getDataPowerWasteChart("mainFour", 0);
    this.getDataPowerWasteChart("mainFive", 1);
    this.getDataPowerWasteChart("mainSix", 2);

    this.getNumericalAttributeList2(0);
    this.getNumericalAttributeList2(1);
    this.getNumericalAttributeList3(2);
  },
  methods: {
    toDeviceManagement(item) {
      this.$router.push({
        name: "deviceManagement",
        query: {
          id: item.deviceId,
          currentShow: "second",
        },
      });
    },
    async initcx() {
      await this.getConfigDataAnalysis(0); //0:环境参数，1，土壤参数，2采集次数
      await setTimeout(() => {
        this.getConfigDataAnalysis(1);
      }, 1000);
      await setTimeout(() => {
        this.getConfigDataAnalysis(2);
      }, 1000);
    },
    inite() {
      this.getDataPowerWasteChart("mainFour", 0);
      this.getDataPowerWasteChart("mainFive", 1);
      this.getDataPowerWasteChart("mainSix", 2);
    },
    getModelAttributeData() {
      this.$api.system
        .getModelAttributeData(
          this.form.attributeId, //属性id
          this.form.deviceId, //设备id
          this.id, //大棚id
          this.dateType, //时间段类型（0最近10分钟、1最近20分钟、2最近30分钟、3昨天、4七天
          this.endDate, //结束日期，格式yyyy-MM-dd HH:mm:ss
          this.startDate //开始日期，格式yyyy-MM-dd HH:mm:ss
        )
        .then((res) => {
          if (res.code == 200) {
            if (res.data.length == 0) {
              this.show_val = true;
            } else {
              this.show_val = false;
            }
            let xarr = [],
              yarr = [];
            for (let i = 0; i < res.data.length; i++) {
              xarr.push(res.data[i].alarmType);
              yarr.push(res.data[i].num);
            }

            this.initChart(xarr, yarr);
          } else {
            this.$meessage.error(res.msg);
          }
        });
    },
    //获取实时数据
    getNumericalAttributeList2(type) {
      this.envarr = [];
      var pageNum = 1;
      var pageSize = 5;
      var attributeName = "";
      var deviceType = "";
      var name = "";
      var status = "";
      this.$api.system
        .getNumericalAttributeList2(
          pageNum,
          pageSize,
          attributeName,
          deviceType,
          this.id,
          name,
          type,
          status
        )
        .then((res) => {
          if (res.code == 200) {
            this.envarr = res.data;
          }
        });
    },
    getNumericalAttributeList3(type) {
      this.envarr2 = [];
      var pageNum = 1;
      var pageSize = 5;
      var attributeName = "";
      var deviceType = "";
      var name = "";
      var status = "";
      this.$api.system
        .getNumericalAttributeList2(
          pageNum,
          pageSize,
          attributeName,
          deviceType,
          this.id,
          name,
          type,
          status
        )
        .then((res) => {
          if (res.code == 200) {
            this.envarr2 = res.data;
          }
        });
    },
    //获取X轴数据分析配置条件（0环境参数，1土壤参数，2告警次数）
    async getConfigDataAnalysis(type) {
      await this.$api.system.getConfigDataAnalysis(type).then((res) => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            var arr = [];
            var arr2 = [];
            for (var i = 0; i < res.data.length; i++) {
              var obj = {};
              obj.eid = res.data[i].eid;
              obj.attributeId = res.data[i].attributeId;

              arr.push(res.data[i].attributeName);
              arr2.push(obj);
            }
            if (type == 0) {
              this.paramType = "0";
              this.hjempty = true;
              this.dynamicTags0 = arr;
              this.attributes = arr2;
              this.$forceUpdate();
              this.getDataHisStatisticChart2(0);
            } else if (type == 1) {
              this.paramType = "1";
              this.trempty = true;
              this.dynamicTags1 = arr;
              this.attributes1 = arr2;
              this.getDataHisStatisticChart2(1);
            } else if (type == 2) {
              this.paramType = "2";
              this.trempty = true;
              this.dynamicTags2 = arr;
              this.attributes2 = arr2;
              this.getDataHisStatisticChart3();
            }
          }
        }
      });
    },
    // 删除属性
    handleClosetag(tag) {
      if (this.paramType == "0") {
        this.attributes.splice(this.dynamicTags.indexOf(tag), 1);
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        this.dynamicTags0.splice(this.dynamicTags0.indexOf(tag), 1);
        this.getDataHisStatisticChart();
      } else if (this.paramType == "1") {
        this.attributes1.splice(this.dynamicTags.indexOf(tag), 1);
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        this.dynamicTags1.splice(this.dynamicTags1.indexOf(tag), 1);
        this.getDataHisStatisticChart();
      } else {
        this.attributes2.splice(this.dynamicTags.indexOf(tag), 1);
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        this.dynamicTags2.splice(this.dynamicTags2.indexOf(tag), 1);
        this.getDataHisStatisticChart3();
      }
    },

    showInput() {
      this.dialogVisible2 = true;
    },
    // 点击确定添加属性
    handleInputConfirm() {
      // 设备属性名称
      var string = "";
      for (var i = 0; i < this.attributeList.length; i++) {
        if (this.attributeList[i].id == this.attributeId) {
          string = this.attributeList[i].cname;
          break;
        }
      }

      if (this.paramType == "0") {
        this.attributes.push({ eid: this.eid, attributeId: this.attributeId });
        let inputValue = string;

        if (inputValue) {
          if (this.dynamicTags.indexOf(inputValue) != -1) {
            this.$toaster.error("该属性已存在");
            return false;
          }

          this.dynamicTags.push(inputValue);
          this.dynamicTags0.push(inputValue);
        }

        this.hjempty = true;
        this.getDataHisStatisticChart();
      } else if (this.paramType == "1") {
        let inputValue = string;
        this.attributes1.push({ eid: this.eid, attributeId: this.attributeId });
        if (this.dynamicTags.indexOf(inputValue) != -1) {
          this.$toaster.error("该属性已存在");
          return false;
        }
        if (inputValue) {
          this.dynamicTags.push(inputValue);
          this.dynamicTags1.push(inputValue);
        }
        this.trempty = true;
        this.getDataHisStatisticChart();
      } else if (this.paramType == "2") {
        let inputValue = string;
        this.attributes2.push({ eid: this.eid, attributeId: this.attributeId });
        if (this.dynamicTags.indexOf(inputValue) != -1) {
          this.$toaster.error("该属性已存在");
          return false;
        }
        if (inputValue) {
          this.dynamicTags.push(inputValue);
          this.dynamicTags2.push(inputValue);
        }
        this.gjempty = true;
        this.getDataHisStatisticChart3();
      }
      this.dialogVisible2 = false;
    },
    getDataPowerWasteChart(id, type) {
      //0电压、1电流、2有功电度
      if (this.value4) {
        var startDate = this.value4[0] + " 00:00:00";
        var endDate = this.value4[1] + " 23:59:59";
      } else {
        var startDate = "2020-03-30 00:00:00";
        var endDate = "2020-03-30 23:59:59";
      }

      var dto = {
        endDate: endDate,
        type: type,
        startDate: startDate,
      };
      this.$api.system.getDataPowerWasteChart(dto).then((res) => {
        if (res.code == 200) {
          var datamax = [];
          var datave = [];
          var datamin = [];
          var xTimes = [];
          for (var i = 0; i < res.data.xTimes.length; i++) {
            xTimes.push(this.$utils.zhDatetime(res.data.xTimes[i]));
          }
          for (var i = 0; i < res.data.yDatas.length; i++) {
            datamax.push(res.data.yDatas[i].maxValue);
            datave.push(res.data.yDatas[i].averageValue);
            datamin.push(res.data.yDatas[i].minValue);
          }
          this.initEcharts(id, xTimes, datamax, datave, datamin);
        }
      });
    },
    // 获取环境参数图表
    async getDataHisStatisticChart() {
      if (this.value3) {
        var startDate = this.value3[0] + " 00:00:00";
        var endDate = this.value3[1] + " 23:59:59";
      } else {
        var startDate = "2020-03-30 00:00:00";
        var endDate = "2020-03-30 23:59:59";
      }
      if (this.attributeId == "") {
        return;
      }
      if (this.paramType == "0") {
        var arr = this.attributes;
      } else {
        var arr = this.attributes1;
      }
      var dto = {
        attributes: arr,
        startDate: startDate,
        paramType: this.paramType,
        endDate: endDate,
      };
      await this.$api.system.getDataHisStatisticChart(dto).then((res) => {
        if (res.code == 200) {
          var datax = [];
          var datayy = [];
          var color = ["#0356FE", "#2ec7c9", "#b6a2de", "#5ab1ef"];
          var color2 = ["#d2e9ef", "#91dedf", "#d5cbe9", "#a7d3f2"];

          for (var j = 0; j < res.data.xTimes.length; j++) {
            datax.push(this.$utils.zhDatetime(res.data.xTimes[j]));
          }
          var title = [];
          for (var i = 0; i < res.data.yDatas.length; i++) {
            //这层遍历出几个属性
            var datay = [];

            for (var k = 0; k < res.data.yDatas[i].statistics.length; k++) {
              //这层遍历出该属性下的所有点的数据
              datay.push(
                parseFloat(
                  res.data.yDatas[i].statistics[k].averageValue
                ).toFixed(2)
              );
            }
            title.push(res.data.yDatas[i].attributeName);
            var obj = {
              name: res.data.yDatas[i].attributeName,
              data: datay, //[820, 932, 901, 934, 1290, 1130, 1020, 1120, 1340, 1220, 1520],
              type: "line",
              smooth: true,
              symbolSize: 0,
              itemStyle: {
                normal: {
                  // color:'#0356FE',
                  color: color[i],
                  lineStyle: {
                    //color:'#0356FE'
                    color: color[i],
                  },
                },
              },
            };
            datayy.push(obj);
          }

          this.dialogEcharts(datax, datayy, title);
          this.isloading = false;
        }
      });
    },
    //获取土壤参数图表
    async getDataHisStatisticChart2(type) {
      if (this.value3) {
        var startDate = this.value3[0] + " 00:00:00";
        var endDate = this.value3[1] + " 23:59:59";
      } else {
        var startDate = "2020-03-30 00:00:00";
        var endDate = "2020-03-30 23:59:59";
      }
      if (type == "0") {
        var arr = this.attributes;
      } else {
        var arr = this.attributes1;
      }
      var dto = {
        attributes: arr,
        endDate: endDate,
        paramType: type,
        startDate: startDate,
      };
      await this.$api.system.getDataHisStatisticChart(dto).then((res) => {
        if (res.code == 200) {
          var datax = [];
          var datayy = [];
          var color = ["#0356FE", "#2ec7c9", "#b6a2de", "#5ab1ef"];
          var color2 = ["#d2e9ef", "#91dedf", "#d5cbe9", "#a7d3f2"];

          for (var j = 0; j < res.data.xTimes.length; j++) {
            datax.push(this.$utils.zhDatetime(res.data.xTimes[j]));
          }
          var title = [];
          for (var i = 0; i < res.data.yDatas.length; i++) {
            //这层遍历出几个属性
            var datay = [];

            for (var k = 0; k < res.data.yDatas[i].statistics.length; k++) {
              //这层遍历出该属性下的所有点的数据
              datay.push(
                parseFloat(
                  res.data.yDatas[i].statistics[k].averageValue
                ).toFixed(2)
              );
            }
            title.push(res.data.yDatas[i].attributeName);
            var obj = {
              name: res.data.yDatas[i].attributeName,
              data: datay, //[820, 932, 901, 934, 1290, 1130, 1020, 1120, 1340, 1220, 1520],
              type: "line",
              smooth: true,
              symbolSize: 0,
              itemStyle: {
                normal: {
                  // color:'#0356FE',
                  color: color[i],
                  lineStyle: {
                    //color:'#0356FE'
                    color: color[i],
                  },
                },
              },
            };
            datayy.push(obj);
          }

          this.dialogEcharts(datax, datayy, title);
          this.isloading = false;
        }
      });
    },
    // 查询大棚下的所有传感器
    async getNumericalsByGroupId() {
      this.deviceList = [];
      this.eid = "";
      this.attributeList = [];
      this.attributeId = "";
      await this.$api.system
        .getNumericals2(this.id, this.paramType2)
        .then((res) => {
          if (res.code == 200) {
            this.deviceList = res.data;
            this.eid = res.data[0].id;
            this.getNumericalAttributeListTwo(res.data[0].id);
          }
        });
    },
    // 查询传感器设备属性列表
    async getNumericalAttributeListTwo(id) {
      this.attributeList = [];
      this.attributeId = "";
      await this.$api.system.getModelRuleAttributes(id).then((res) => {
        if (res.code == 200) {
          this.attributeList = res.data;
          this.attributeId = res.data[0].id;
        }
      });
    },
    //查询大棚下所有的摄像头
    getVideos(id) {
      this.$api.device.getVideosByGroupId({ id: id }).then((res) => {
        if (res.code == 200) {
          if (res.data.length == 0) {
            this.getVideosListname = "暂无摄像头";
            this.getVideosListplayRtmp = "";
            this.getVideosListplayM3u8 = "";
          } else {
            this.getVideosListname = res.data[1].name;
            this.getVideosListplayRtmp = res.data[1].playRtmp;
            this.getVideosListplayM3u8 = res.data[1].playM3u8;
          }
        }
      });
    },
    //
    value_val(val) {
      this.getNumericalAttributeListTwo(val);
    },
    open() {
      const t = this;
      setTimeout(() => {
        //  执行echarts画图方法
        // t.dialogEcharts();
      }, 0);
    },
    timeSwitch(id) {
      this.timeType = id;
    },
    // 打开图表设置
    dialogShow(type) {
      this.dialogVisible = true;
      var _this = this;

      if (type == "0") {
        // 环境参数
        this.paramType = 0;
        this.paramType2 = 0;
        this.dialogShowname = "环境参数图表设置";
        this.dynamicTags = this.dynamicTags0.concat();
        this.getDataHisStatisticChart();
      } else if (type == "1") {
        // 土壤参数
        this.paramType = 1;
        this.paramType2 = 2;
        this.dialogShowname = "土壤参数图表设置";
        this.dynamicTags = this.dynamicTags1.concat();
        this.getDataHisStatisticChart();
      } else if (type == "2") {
        // 告警次数
        this.paramType = 2;
        this.paramType2 = undefined;
        this.dialogShowname = "告警次数图表设置";
        this.dynamicTags = this.dynamicTags2.concat();
        setTimeout(function () {
          _this.getDataHisStatisticChart3();
        }, 200);
      }

      this.getNumericalsByGroupId(this.id);
    },
    async getDataHisStatisticChart3() {
      if (this.value3) {
        var startDate = this.value3[0] + " 00:00:00";
        var endDate = this.value3[1] + " 23:59:59";
      } else {
        var startDate = "2020-03-30 00:00:00";
        var endDate = "2020-03-30 23:59:59";
      }
      var arr = this.attributes2;
      var dto = {
        attributes: arr,
        startDate: startDate,
        paramType: this.paramType,
        endDate: endDate,
      };
      await this.$api.system.getDataHisAlarmChart(dto).then((res) => {
        if (res.code == 200) {
          let list = res.data;
          let x_data = [];
          let y_data = [];
          for (let i of list) {
            x_data = [...x_data, i.alarmType];
            y_data = [...y_data, i.num];
          }
          var myChart2 = echarts.init(document.getElementById("mainThree"));
          if (document.getElementById("mainSeven") != null) {
            var myChart6 = echarts.init(document.getElementById("mainSeven"));
            myChart6.clear();
          }
          var option2 = {
            legend: {
              data: x_data,
            },
            xAxis: {
              type: "category",
              data: x_data,
            },
            yAxis: {
              type: "value",
            },
            series: [
              {
                data: y_data,
                type: "bar",
              },
            ],
          };
          if (document.getElementById("mainSeven") != null) {
            myChart6.setOption(option2);
          }
          myChart2.setOption(option2);
        }
      });
    },
    handleClose1() {
      this.dialogVisible = false;
    },
    handleClose2() {
      this.dialogVisible2 = false;
    },
    timeSwitch1(id) {
      this.timeType1 = id;
    },
    jkShow() {
      this.centerDialogVisible = true;
    },
    handleClose() {
      this.centerDialogVisible = false;
    },
    drawLine(datax, datayy, title) {
      var myChart = echarts.init(document.getElementById("mainSeven1"));
      myChart.clear();
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          position: function (pt) {
            return [pt[0], "10%"];
          },
          //formatter: "{a}: {c} ({d}%)"
        },
        legend: {
          data: title,
          top: 20,
        },
        markPoint: {
          type: "max",
        },
        xisLabel: { interval: 0, rotate: 40 },
        /***** */
        markPoint: {
          data: [
            { type: "max", name: "最大值" },
            { type: "min", name: "最小值" },
          ],
        },
        markLine: {
          data: [{ type: "average", name: "平均值" }],
        },
        /****** */
        grid: {
          top: 60,
          left: 60,
          right: 100,
          bottom: 50,
        },
        xAxis: {
          xisLabel: { interval: 0, rotate: 40 },
          name: "",
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            interval: 0, //代表显示所有x轴标签显示
            rotate: 4, //代表逆时针旋转45度
          },
          type: "category",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#EBEEF5",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#c1c1c1",
              fontSize: 10,
            },
            margin: 16, //刻度标签与轴线之间的距离。
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#EBEEF5"],
              width: 1,
              type: "solid",
            },
          },
          data: datax, //['17:22:00', '17:24:00', '17:26:00', '17:28:00', '17:30:00', '17:32:00', '17:34:00', '17:36:00', '17:38:00', '17:40:00', '17:42:00']
        },
        yAxis: {
          name: "数值",
          nameTextStyle: {
            color: "#54627D",
            //align:"right",
            padding: [80, 5, 10, -20],
            fontSize: 12,
          },
          axisLine: {
            lineStyle: {
              color: "#EBEEF5",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#54627D",
              fontSize: 10,
            },
            margin: 20, //刻度标签与轴线之间的距离。
          },
          type: "value",
          min: "100",
          max: "1000",

          splitNunber: 1,
          splitLine: {
            show: false,
            lineStyle: {
              color: ["#EBEEF5"],
              width: 1,
              type: "solid",
            },
          },
        },
        series: datayy,
      });
    },
    // 图表
    dialogEcharts(xDate, YDate, title) {
      // 环境参数
      var myChart7 = echarts.init(document.getElementById("mainOne"));

      // 土壤参数
      var myChart72 = echarts.init(document.getElementById("mainTwo"));

      // 图表配置参数弹窗
      if (document.getElementById("mainSeven") != null) {
        var myChart6 = echarts.init(document.getElementById("mainSeven"));
        myChart6.clear();
      }

      if (this.paramType == "0") {
        myChart7.clear();
      } else {
        myChart72.clear();
      }

      var option = {
        tooltip: {
          trigger: "axis",
          position: function (pt) {
            return [pt[0], "10%"];
          },
          //formatter: "{a}: {c} ({d}%)"
        },
        dataZoom: [
          {
            show: true,
            realtime: true,
            start: 0,
            end: 100,
          },
          {
            type: "inside",
            realtime: true,
            start: 0,
            end: 100,
          },
        ],
        legend: {
          data: title,
          x: "center", //可设定图例在左、右、居中
          y: "bottom",
          itemHeight: 2,
          itemWidth: 16,
          padding: [50, 50, 50, 50],
          icon: "rect",
        },
        xAxis: {
          name: "",
          nameTextStyle: {
            color: "#c1c1c1",
            padding: [46, 5, 5, 18],
            fontSize: 12,
          },
          type: "category",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#EBEEF5",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#c1c1c1",
              fontSize: 10,
            },
            margin: 16, //刻度标签与轴线之间的距离。
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#EBEEF5"],
              width: 1,
              type: "solid",
            },
          },
          data: xDate,
        },
        yAxis: {
          name: "数值",
          nameTextStyle: {
            color: "#54627D",
            //align:"right",
            padding: [80, 5, 10, -20],
            fontSize: 12,
          },
          axisLine: {
            lineStyle: {
              color: "#EBEEF5",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#54627D",
              fontSize: 10,
            },
            margin: 20, //刻度标签与轴线之间的距离。
          },
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#EBEEF5"],
              width: 1,
              type: "solid",
            },
          },
        },
        series: YDate,
        grid: {
          x: 30,
          x2: 20,
          y: 20,
          left: 60,
          bottom: 100,
        },
      };
      var option1 = {
        tooltip: {
          trigger: "axis",
          position: function (pt) {
            return [pt[0], "10%"];
          },
          //formatter: "{a}: {c} ({d}%)"
        },
        grid: {
          top: 10,
          bottom: 80,
          left: 70,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: title,
          x: "center", //可设定图例在左、右、居中
          y: "bottom",
          itemHeight: 2,
          itemWidth: 16,
          icon: "rect",
        },
        xAxis: {
          name: "",
          nameTextStyle: {
            color: "#c1c1c1",
            padding: [46, 5, 5, 18],
            fontSize: 12,
          },
          type: "category",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#EBEEF5",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#c1c1c1",
              fontSize: 10,
            },
            margin: 16, //刻度标签与轴线之间的距离。
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#EBEEF5"],
              width: 1,
              type: "solid",
            },
          },
          data: xDate,
        },
        yAxis: {
          name: "数值",
          nameTextStyle: {
            color: "#54627D",
            //align:"right",
            padding: [10, 1, 1, -10],
            fontSize: 12,
          },
          axisLine: {
            lineStyle: {
              color: "#EBEEF5",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#54627D",
              fontSize: 10,
            },
            margin: 20, //刻度标签与轴线之间的距离。
          },
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#EBEEF5"],
              width: 1,
              type: "solid",
            },
          },
        },
        series: YDate,
      };
      if (document.getElementById("mainSeven") != null) {
        myChart6.setOption(option);
      }

      if (this.paramType == "0") {
        myChart7.setOption(option1);
      } else {
        myChart72.setOption(option1);
      }
    },

    initEcharts(id, datax, datxy, datxy2, datxy3) {
      // 基于准备好的dom，初始化echarts实例
      var myChart3 = echarts.init(document.getElementById(id));
      myChart3.clear();

      // 指定图表的配置项和数据
      var option3 = {
        grid: {
          top: 10,
          left: 70,
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["最大值", "平均值", "最小值"],
          x: "center", //可设定图例在左、右、居中
          y: "bottom",
          itemHeight: 2,
          itemWidth: 16,
          icon: "rect",
        },
        xAxis: {
          name: "时间",
          nameTextStyle: {
            color: "#c1c1c1",
            padding: [46, 5, 5, 18],
            fontSize: 12,
          },
          type: "category",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: "#EBEEF5",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#c1c1c1",
              fontSize: 10,
            },
            margin: 16, //刻度标签与轴线之间的距离。
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#EBEEF5"],
              width: 1,
              type: "solid",
            },
          },
          data: datax, //["周一", "周二", "周三", "周四", "周五", "周六", "周日"]
        },
        yAxis: {
          yAxis: {
            name: "数值",
            nameTextStyle: {
              color: "#54627D",
              //align:"right",
              padding: [80, 5, 10, -20],
              fontSize: 12,
            },
            axisLine: {
              lineStyle: {
                color: "#333",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#54627D",
                fontSize: 10,
              },
              margin: 20, //刻度标签与轴线之间的距离。
            },
            type: "value",
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#EBEEF5"],
                width: 1,
                type: "solid",
              },
            },
          },
          type: "value",
        },
        series: [
          {
            data: datxy, //[8, 8.3, 10, 10.3, 9, 11, 12],
            type: "line",
            name: "最大值",

            smooth: true,
            symbolSize: 0,
          },
          {
            data: datxy2, //[4, 5, 5.8, 7, 4.8, 7.5, 8],
            type: "line",
            name: "平均值",
            smooth: true,
            symbolSize: 0,
          },
          {
            data: datxy3, // [2, 3, 2.8, 4, 3.7, 5, 6],
            type: "line",
            name: "最小值",
            smooth: true,
            symbolSize: 0,
          },
        ],
      };
      myChart3.setOption(option3);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/greenhouseManagement.scss";

li {
  padding-left: 15px;
}
.el-tag {
  margin-right: 10px !important;
}
.empty-div {
  width: 376px;
  height: 273px;
  background: #fff;
  text-align: center;
  line-height: 273px;
  border-radius: 12px;
  cursor: pointer;
  margin-top: 20px;
  letter-spacing: 2px;
  color: #999;
}
.sz-btn {
  float: right;
  width: 50px;
  text-align: center;
  font-size: 12px;
  line-height: 24px;
  background: #ddd;
  color: #fff;
  border-radius: 4px;
}
.gzImg2 {
  width: 41px;
  height: 40px;
  float: left;
  margin-left: 10px;
}
</style>